<p-tabs [value]="activeTab">
    <p-tablist>
        <p-tab value="notifications">
            <i class="pi pi-bell"></i>
            {{ 'layout.notifications.header' | translate }}
        </p-tab>
        <p-tab value="recentlyVisited">
            <i class="pi pi-clock"></i>
            {{ 'layout.recentlyVisited.header' | translate }}
        </p-tab>
    </p-tablist>

    <p-tabpanels>
        <p-tabpanel value="notifications">
            <app-notifications></app-notifications>
        </p-tabpanel>
        <p-tabpanel value="recentlyVisited">
            <app-recently-visited></app-recently-visited>
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>

<div #dialogFooter class="p-dialog-footer"></div>
